<template>
  <div class="carousel-card">
    <div class="px-lg-5">
      <div 
        class="carousel-container px-lg-5"
        @touchstart="onTouchStart"
        @touchmove="onTouchMove"
        @touchend="onTouchEnd"
      >
        <div 
          class="col-md-4  "
          v-for="(card, index) in displayedCards" 
          :key="card.id"
        >
          <div class="bg-card shadow rounded border card-hover-wrapper">
            <div>
              <div class="image-container bg-icon-primary">
                <div v-if="isLoadingImages" class="image-loader">
                  <div class="spinner"></div>
                </div>
                  
                <img v-if="card.ImgUrl1" :src="card.ImgUrl" :alt="card.tittle || 'Artículo del blog'" class="carousel-image zoomImg" width="800" height="450" loading="lazy" decoding="async" @load="handleImageLoad"/>
                <div v-else>
                  <div class="circle bg-icon-primary big zoomImg">
                    <i class="fa-solid fa-image primary"></i>
                  </div>
                </div>
                <div class="badge-container-down pl-3">
                  <div class="  sqare-content p-2 bg-light d-block" >
                    <div class="text-center pt-1">                        
                      <h5  class="mb-0 text-secondary" sty >18</h5>
                      <span style="font-size: 13px;" class="text-secondary">{{ $t('blog.september') }}</span>
                    </div>
                  </div>
                   
                </div>
                
              </div>
              <div class="content-container p-4"  >
                <span class="text-secondary"><i class="fa-solid fa-location-dot "></i> {{ card.date }}</span>
                <h4 class="title-card"   >
                  {{ card.tittle.length > 15 ? card.tittle.substring(0, 15) + '...' : card.tittle  }}
                </h4>
                <p class="text-secondary pb-0">
                  {{ card.detail.length > 70 ? card.detail.substring(0, 70) + '...' : card.detail }}
                </p>
                <router-link :to="blogPath(card)" class="a-left">{{ $t('blog.readMore') }}</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { buildBlogPath } from "@/utils/blogUrl";

export default {
  props: ["detail"],
  data() {
    return {
      displayedCards: [],
      interval: null,
      currentIndex: 0,
      startX: 0,
      endX: 0,
      isLoadingImages: true,
    };
  },
  mounted() {
    this.initializeCarousel();
    this.startAutoSlide();
  },
  beforeDestroy() {
    this.stopAutoSlide();
  },
  methods: {
    blogPath(card) {
      // Re-evalua al cambiar el locale: si el user esta en /en/blog
      // los links de las cards se generan con /en/ prefix; si esta
      // en /es/blog, sin prefix (default).
      return card.ruta || buildBlogPath({
        Id: card.Id || card.id,
        Titulo_Esp: card.tittle
      }, this.$i18n.locale);
    },
    handleImageLoad() {
      this.isLoadingImages = false;
    },
    initializeCarousel() {
      this.displayedCards = [...this.detail.slice(0, 3)];
    },
    shiftCards() {
      if (this.detail.length > 3) {
        this.displayedCards.push(this.detail[this.currentIndex]);
        this.displayedCards.shift();
        this.currentIndex = (this.currentIndex + 1) % this.detail.length;
      }
    },
    startAutoSlide() {
      this.interval = setInterval(this.shiftCards, 2000);
    },
    stopAutoSlide() {
      clearInterval(this.interval);
    },
    onTouchStart(event) {
      this.startX = event.touches[0].clientX;
    },
    onTouchMove(event) {
      this.endX = event.touches[0].clientX;
    },
    onTouchEnd() {
      const deltaX = this.endX - this.startX;
      if (Math.abs(deltaX) > 50) { // Umbral para evitar movimientos accidentales
        deltaX < 0 ? this.shiftCards() : this.shiftCardsBackward();
      }
    },
    shiftCardsBackward() {
      if (this.detail.length > 3) {
        this.currentIndex = (this.currentIndex - 1 + this.detail.length) % this.detail.length;
        this.displayedCards.unshift(this.detail[this.currentIndex]);
        this.displayedCards.pop();
      }
    },
  },
};
</script>

<style scoped>
.sqare-content{
  width: 100%;
  height: 100%;

}
 

.title-card {
  text-wrap:inherit;
  color: var(--dark) !important;
  transition: 0.3s;
}
.title-card:hover {
  color: var(--primary) !important;
}
.a-left {
  color: var(--text-secondary) !important;
  font-weight: bold;
  text-align: left;
  position: relative;
  display: inline-block;
  cursor: pointer;
}
.a-left::after {
  content: "";
  position: absolute;
  bottom: -5px;
  left: 0;
  height: 3px;
  background-color: var(--primary);
  width: 0%;
  transition: all 0.3s ease;
}
.a-left:hover::after {
  color: var(--primary) !important;
}
.card-hover-wrapper:hover .title-card {
  color: var(--primary) !important;
}
.card-hover-wrapper:hover .a-left::after {
  color: var(--primary) !important;
  width: 80%;
}
.card-hover-wrapper:hover .a-left{
  color: var(--primary) !important;
}

.zoomImg {
  transition: all 300ms !important;
 
}
.card-hover-wrapper:hover .zoomImg {
  transform: scale(1.05) !important;

}
.image-container {
  width: auto;
  height: 16rem;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  /* border-radius: 10px; */
}
.image-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.image-loader {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--primary-light);
  z-index: 5;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top-color: var(--primary);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.image-container {
  position: relative;
}

.carousel-container {
  overflow: hidden;
  position: relative;
  display: flex;
}
@media (max-width: 576px) {
  .card-hover-wrapper {
    width: 90vw;
  }
}
</style>
